/* eslint-disable react/no-unescaped-entities */
/* eslint-disable camelcase */
import { Card, Form, Button, Row, Alert, Col } from 'react-bootstrap';
import Descriptions from '@uiw/react-descriptions';
import { Link } from 'react-router-dom';
import { loaderActions } from '../../../features/Loader/LoaderSlice';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';
import {
  validatePurchaseLine,
  validateTransferLine,
  isSeafreightShipped
} from '../../../Helpers/line.validation';

import API from '../../../Services/API';
import Swal from 'sweetalert2';
import { useCurrentCompanyID } from '../../../hooks/useCurrentCompany';
import { formatDateTime } from '../../../Helpers/date';
import './checkbox.scss';
import { orderAction } from '../../../features/Order/OrderSlice';
import { SocketActions } from '../../../features/Socket/SocketSlice';
import { CheckRequireApproval } from '../../../Helpers/requireApproval';
import { useEffect, useMemo, useState } from 'react';
import InfoBox from './InfoBox';

function OrderLine({
  documentNo,
  line,
  index,
  vendorType,
  type,
  editValue,
  refresh,
  showSaveButton,
  showOrderLink,
  directLink,
  orderLines,
  isFeedbackProcess = false,
  isBackendLines = false
}) {
  const dispatch = useDispatch();
  const companyId = useCurrentCompanyID();
  const { can_approve_po } = useSelector((state) => state.auth);
  const { isFeedBackLoopEnabled } = useSelector((state) => state.general);
  const { currentOrder } = useSelector((state) => state.order);
  const [customReason, setCustomReason] = useState(false);
  const lossReasonOptions = [
    '',
    'Capacity Constraints',
    'Production Issues',
    'Cover Delays',
    'Material Shortages',
    'Quality Issues',
    'No WH Slots',
    'Logistic or Transport Issues',
    'IT Issues',
    'Payment Issues',
    'Order > agreed Capacity',
    'Wrong Leadtimes Assumption',
    'Last Minute changes in Order',
    'Prioritization of other Orders',
    'Wrong Truck Rounding',
    'Other (open answer)'
  ];
  const isSupplier = vendorType && vendorType.toLowerCase() === 'supplier';
  const isTransferLine = type === 'transfer';
  const isSeafreightLocked = type === 'purchase' && isSeafreightShipped(line);

  useEffect(() => {
    if (!isTransferLine && !isSupplier) {
      editValue(documentNo, line.lineNo, { SkipPriceValidation: true });
    }
  }, [isTransferLine, isSupplier, documentNo, line.lineNo, line.SkipPriceValidation]);

  const [CountriesOptions, setOptions] = useState([]);
  const maxDate = new Date(Date.now() + 86400 * 1000 * 365).toISOString().split('T')[0];

  const [expectedReceiptDate, setExpectedReceiptDate] = useState(
    line.expectedReceiptDate === '0001-01-01' ? '' : line.expectedReceiptDate
  );
  const [expectedReceiptDateState, setIsInvalidExpectedDate] = useState(false);

  const [actualReceiptDate, setActualReceiptDate] = useState(
    line.actualReceiptDate === '0001-01-01' ? '' : line.actualReceiptDate
  );
  const [actualReceiptDateState, setIsInvalidActualDate] = useState(false);

  const [priceRequiredConfirmation, setPriceRequiredConfirmation] = useState(
    line.vpDirectUnitCost === 0 ? true : line.isVpDirectUnitCostEditable === true
  );
  useEffect(() => {
    if (isBackendLines && isSupplier) {
      setPriceRequiredConfirmation(
        line.vpDirectUnitCost === 0 || line.isVpDirectUnitCostEditable === true
      );
    }
  }, [isBackendLines, line.vpDirectUnitCost, line.isVpDirectUnitCostEditable]);

  const [inputValue, setInputValue] = useState(() => {
    if (
      line.vpDirectUnitCost !== undefined &&
      line.vpDirectUnitCost !== null &&
      line.vpDirectUnitCost !== 0 &&
      isSupplier
    ) {
      return String(Number(line.vpDirectUnitCost));
    } else if (
      line.vpDirectUnitCost === 0 &&
      line.directUnitCost !== undefined &&
      line.directUnitCost !== null &&
      isSupplier
    ) {
      // Mark as edited so save button appears
      editValue(documentNo, line.lineNo, { vpDirectUnitCost: Number(line.directUnitCost) });
      return String(Number(line.directUnitCost));
    } else {
      return '';
    }
  });

  useEffect(() => {
    if (
      line.vpDirectUnitCost !== undefined &&
      line.vpDirectUnitCost !== null &&
      line.vpDirectUnitCost !== 0 &&
      isSupplier
    ) {
      setInputValue(String(Number(line.vpDirectUnitCost).toFixed(2)));
    } else if (
      line.vpDirectUnitCost === 0 &&
      line.directUnitCost !== undefined &&
      line.directUnitCost !== null &&
      isSupplier
    ) {
      setInputValue(String(Number(line.directUnitCost).toFixed(2)));
      // Mark as edited so save button appears
      editValue(documentNo, line.lineNo, { vpDirectUnitCost: Number(line.directUnitCost) });
    } else {
      setInputValue('');
    }
  }, [line.vpDirectUnitCost, line.directUnitCost]);

  const handleChange = (e) => {
    const val = e.target.value.replace(',', '.');
    // Allow only numbers and dot
    if (/^\d*\.?\d{0,2}$/.test(val) || val === '') {
      setInputValue(val);
    }
  };

  const handleBlur = () => {
    const num = parseFloat(inputValue);
    if (!isNaN(num)) {
      editValue(documentNo, line.lineNo, {
        vpDirectUnitCost: num
      });
      setInputValue(num.toFixed(2));
    }
  };

  useMemo(() => {
    async function fetchOriginCountry() {
      try {
        const response = await API().get(`/countries_regions?company_id=${companyId}`);
        const countriesNamesMap = response.data.value.map((country) => country.code);
        setOptions(countriesNamesMap);
      } catch (error) {
        toast('Failed to fetch countries list', { icon: 'error' });
      } finally {
        dispatch(loaderActions.hide());
      }
    }

    fetchOriginCountry();
  }, [companyId]);

  const hideVendorPortalStatus = useMemo(() => {
    if (vendorType && vendorType.toLowerCase() === 'warehouse') {
      if (line.vendorPortalStatusCaption === 'Confirmation Sent to Vendor') {
        return true;
      }
    }

    if (type === 'transfer') {
      return true;
    }
    return false;
  }, [vendorType, line]);

  async function saveTransferLine() {
    const validatedLine = await validateTransferLine(line);

    editValue(documentNo, line.lineNo, {
      isValid: validatedLine.isValid
    });

    editValue(documentNo, line.lineNo, {
      validationErrors: validatedLine.validationErrors
    });

    editValue(documentNo, line.lineNo, {
      validationWarnings: validatedLine.validationWarnings
    });

    if (!validatedLine.isValid) {
      toast.error('Please fix all invalid inputs');
      return false;
    } else {
      Swal.fire({
        title: 'Are you sure?',
        text: "Please make sure everything is uploaded properly, You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Save it!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          dispatch(loaderActions.show());
          const data = {};
          line.editedFields.forEach((field) => {
            if (field === 'qtyReceived') {
              data.qtyToReceive = line[field];
            } else {
              data[field] = line[field];
            }
          });
          const res = await API().patch(
            `/transfer_save_button?(${companyId})?('${line.documentNo}',${line.lineNo},'${line.itemNo}')`,
            data
          );
          if (res.data && typeof res.data === 'object' && res.data.error) {
            toast.error(res.data.error.message);
          } else if (res.response && res.response.status >= 400) {
            toast.error(res.response.data.message);
          } else if (res.code === 'ERR_NETWORK') {
            toast.error(res.message);
          } else {
            toast.success('Order line saved successfully');
            refresh();
          }
          dispatch(loaderActions.hide());
        }
      });
    }
  }

  async function savePurchaseLine() {
    if (isSeafreightLocked) {
      toast.error('This line has already been shipped and quantities cannot be updated.');
      return;
    }
    const validatedLine = await validatePurchaseLine(
      line,
      vendorType,
      orderLines,
      isFeedBackLoopEnabled
    );

    editValue(documentNo, line.lineNo, {
      isValid: validatedLine.isValid
    });

    editValue(documentNo, line.lineNo, {
      validationErrors: validatedLine.validationErrors
    });

    editValue(documentNo, line.lineNo, {
      validationWarnings: validatedLine.validationWarnings
    });

    if (!validatedLine.isValid) {
      toast.error('Please fix all invalid inputs');
      return false;
    } else {
      let result;
      let showPopup = false;
      if (vendorType === 'Warehouse') {
        if (CheckRequireApproval(line, isFeedBackLoopEnabled)) {
          showPopup = true;
        }
      }

      if (isFeedBackLoopEnabled && showPopup) {
        result = await Swal.fire({
          title: 'The amount is over and the PO will need to be approved',
          text: "Please make sure everything is uploaded properly, You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Save it!',
          customClass: {
            title: 'swal2-title-red'
          }
        });
      } else {
        result = await Swal.fire({
          title: 'Are you sure?',
          text: "Please make sure everything is uploaded properly, You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Save it!'
        });
      }
      if (result.isConfirmed) {
        dispatch(loaderActions.show());
        let baseUrl = '';
        if (vendorType.toLowerCase() === 'warehouse') {
          baseUrl = 'warehouse_save_button';
        } else {
          baseUrl = 'supplier_save_button';
        }
        const data = {};
        line.editedFields.forEach((field) => {
          data[field] = line[field];
        });
        try {
          const res = await API().patch(
            `/${baseUrl}?(${companyId})?('${line.documentNo}',${line.lineNo},'${line.itemNo}')`,
            data
          );
          if (res.data && typeof res.data === 'object' && res.data.error) {
            toast.error(res.data.error.message);
          } else if (res.response && res.response.status >= 400) {
            toast.error(res.response.data.message);
          } else if (res.code === 'ERR_NETWORK') {
            toast.error(res.message);
          } else if (res.code === 'ERR_NETWORK') {
            toast.error(res.message);
          } else {
            toast.success('Order line saved successfully');
            refresh();
          }
        } catch (err) {
          if (err.data && typeof err.data === 'object' && err.data.error) {
            toast.error(err.data.error.message);
          } else if (err.response && err.response.status >= 400) {
            toast.error(err.response.data.message);
          } else {
            toast.error('Unexpected Error');
          }
        } finally {
          setPriceRequiredConfirmation(false);
          dispatch(loaderActions.hide());
        }
      }
    }
  }

  async function submitFeedback(action) {
    let title, message, confirmButtonColor, cancelButtonColor, icon, confirmButtonText;
    if (action === 'reject') {
      title = 'Reject';
      message =
        "Are you sure to do this? once you reject a PO line, You won't be able to revert this!";
      icon = 'warning';
      confirmButtonColor = '#d33';
      cancelButtonColor = '#2ed8b6';
      confirmButtonText = 'Yes, Reject it!';
    } else {
      title = 'Approve';
      message =
        "Are you sure to do this? once you approve a PO line, You won't be able to revert this!";
      icon = 'success';
      confirmButtonColor = '#2ed8b6';
      cancelButtonColor = '#d33';
      confirmButtonText = 'Yes, Approve it!';
    }
    const result = await Swal.fire({
      title,
      text: message,
      icon,
      showCancelButton: true,
      confirmButtonColor,
      cancelButtonColor,
      confirmButtonText,
      cancelButtonText: 'Close'
    });
    if (result.isConfirmed) {
      dispatch(loaderActions.show());
      const data = {
        poLine: {
          companyId,
          documentNo: line.documentNo,
          lineNo: line.lineNo,
          itemNo: line.itemNo
        },
        action
      };

      try {
        await API().post(`/purchase-feedback`, data);
        toast.success(`PO line ${action === 'reject' ? 'rejected' : 'approved'} successfully`);
        refresh();
      } catch (error) {
        if (error.response && error.response.status >= 400) {
          if (typeof error.response.data === 'object') {
            toast.error(error.response.data.message);
          } else {
            toast.error(error.response.data);
          }
        } else if (error.data && typeof error.data === 'object' && error.data.error) {
          toast.error(error.data.error.message);
        }
      }
      dispatch(SocketActions.readNotification(`${line.documentNo}-${line.lineNo}`));
      dispatch(loaderActions.hide());
    }
  }

  const lineErrors = line.validationErrors.map((error, index) => {
    return (
      <li className="text-light" key={index}>
        {error}
      </li>
    );
  });

  const lineWarnings = line.validationWarnings.map((warning, index) => {
    return (
      <li className="text-light" key={index}>
        {warning}
      </li>
    );
  });

  let UpdatedableFromSupplier = useMemo(
    () =>
      ['Confirmation Sent to Vendor', 'Confirmed by Vendor'].includes(
        line.vendorPortalStatusCaption
      ),
    [line]
  );

  let ExtendedUpdateableFromSupplier = useMemo(
    () =>
      [
        'Confirmation Sent to Vendor',
        'Confirmed by Vendor',
        'Confirmation Sent to Warehouse'
      ].includes(line.vendorPortalStatusCaption),
    [line]
  );

  let UpdatedableFromWarehouse = useMemo(
    () =>
      [
        'Confirmation Sent to Vendor',
        'Confirmed by Vendor',
        'Confirmation Sent to Warehouse',
        'Confirmed by Warehouse'
      ].includes(line.vendorPortalStatusCaption),
    [line]
  );

  let approvalCol = 0;
  let cardCol = 12;

  let feedbackDate = '';
  if (line.feedbackDate !== '') {
    feedbackDate = formatDateTime(line.feedbackDate);
  }

  async function toggleSelect(documentNo, lineNo, status) {
    dispatch(
      orderAction.toggleSelectOrderLine({
        documentNo,
        lineNo,
        status
      })
    );
  }

  if (
    isFeedBackLoopEnabled === true &&
    isFeedbackProcess === true &&
    line.feedbackStatus === 'Pending'
  ) {
    UpdatedableFromWarehouse = false;
    UpdatedableFromSupplier = false;
    ExtendedUpdateableFromSupplier = false;
    if (line.approvable && can_approve_po) {
      approvalCol = 1;
      cardCol = 11;
    }
  }
  if (isFeedBackLoopEnabled) {
    if (line.feedbackStatus === 'Pending') {
      UpdatedableFromWarehouse = false;
      UpdatedableFromSupplier = false;
      ExtendedUpdateableFromSupplier = false;
    }
    if (line.feedbackStatus === 'Approved') {
      UpdatedableFromWarehouse = false;
      UpdatedableFromSupplier = false;
      ExtendedUpdateableFromSupplier = false;
    }
  }

  if (type === 'transfer') {
    UpdatedableFromSupplier = false;
    ExtendedUpdateableFromSupplier = false;
    UpdatedableFromWarehouse = true;
  }

  return (
    <Card
      className="shadow-sm p-3"
      key={index}
      bg={line.isValid === false ? (line.validationErrors.length > 0 ? 'danger' : 'warning') : ''}
    >
      <Row>
        {approvalCol > 0 && (
          <Col xs={approvalCol} sm={approvalCol} md={approvalCol} lg={approvalCol} xl={approvalCol}>
            <div className="line-select">
              <Form.Group controlId="formBasicCheckbox">
                <Form.Check
                  size="lg"
                  type="checkbox"
                  checked={line.isSelected}
                  onChange={(e) => {
                    toggleSelect(documentNo, line.lineNo, e.target.checked);
                  }}
                />
              </Form.Group>
            </div>
          </Col>
        )}
        <Col xs={cardCol} sm={cardCol} md={cardCol} lg={cardCol} xl={cardCol}>
          <Descriptions bordered className={index > 0 ? 'mt-2' : ''} colon={false}>
            {showOrderLink && (
              <Descriptions.Item label="Order #">
                {isFeedbackProcess === true ? (
                  <Link to={`/purchase-order/${vendorType}/${line.documentNo}`} target="_blank">
                    {line.documentNo}
                  </Link>
                ) : (
                  <Link to={`${directLink}/${vendorType}/${line.documentNo}`} target="_blank">
                    {line.documentNo}
                  </Link>
                )}
              </Descriptions.Item>
            )}
            <Descriptions.Item label="Line #">{line.lineNo}</Descriptions.Item>
            <Descriptions.Item label="Sku Code" span={showOrderLink === true ? 1 : 2}>
              {line.itemNo}
            </Descriptions.Item>
            {vendorType && vendorType.toLowerCase() === 'supplier' && type === 'purchase' && (
              <Descriptions.Item label="Original Unit price" span={1}>
                {line.directUnitCost !== undefined && line.directUnitCost !== null
                  ? Number(line.directUnitCost).toFixed(2)
                  : ''}
              </Descriptions.Item>
            )}
            {vendorType &&
              vendorType.toLowerCase() === 'supplier' &&
              type === 'purchase' &&
              (priceRequiredConfirmation ? (
                <Descriptions.Item
                  label={
                    <InfoBox
                      title={'Unit price to be confirmed'}
                      description="The unit price to be confirmed as final price by the supplier."
                      type={type}
                    />
                  }
                  span={2}
                >
                  <Form.Control
                    size="sm"
                    className="mr-2"
                    type="text"
                    placeholder="Confirm unit price"
                    value={inputValue}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <div className="text-warning mt-1" style={{ fontSize: '0.85em' }}>
                    NOTE: The price can only be confirmed once. If you save this line item, the
                    price will be saved as confirmed.
                  </div>
                </Descriptions.Item>
              ) : (
                <Descriptions.Item
                  label={
                    <InfoBox
                      title="Confirmed Unit price"
                      description="The unit price confirmed as final price by the supplier."
                      type={type}
                    />
                  }
                  span={2}
                >
                  {line.vpDirectUnitCost !== undefined && line.vpDirectUnitCost !== null
                    ? Number(line.vpDirectUnitCost).toFixed(2)
                    : ''}
                </Descriptions.Item>
              ))}
            {!hideVendorPortalStatus && (
              <Descriptions.Item label="Vendor Portal Status" span={3}>
                {line.vendorPortalStatusCaption}
              </Descriptions.Item>
            )}
            {!isFeedbackProcess && (
              <Descriptions.Item label="Description" span={type === 'purchase' ? 2 : 3}>
                {line.description}
              </Descriptions.Item>
            )}
            {type === 'purchase' && (
              <Descriptions.Item label="Vendor Shipment No">
                {UpdatedableFromSupplier && vendorType.toLowerCase() === 'supplier' ? (
                  <Form.Control
                    size="sm"
                    className="mr-2"
                    placeholder="Enter shipment number"
                    value={line.vndrShpmntNo}
                    maxLength={20}
                    onChange={(e) =>
                      editValue(documentNo, line.lineNo, { vndrShpmntNo: String(e.target.value) })
                    }
                  />
                ) : (
                  line.vndrShpmntNo
                )}
              </Descriptions.Item>
            )}
            {vendorType && vendorType.toLowerCase() === 'supplier' && (
              <Descriptions.Item label="Quantity">
                {type === 'purchase' ? line.quantity : line.itemQty}
              </Descriptions.Item>
            )}
            {vendorType && vendorType.toLowerCase() === 'supplier' && (
              <Descriptions.Item
                label={
                  <InfoBox
                    title={type === 'purchase' ? 'Confirmed Quantity' : 'Quantity Shipped'}
                    description="The quantity of items that the supplier is able to fulfill. This value can be modified until the goods are shipped"
                    type={type}
                  />
                }
              >
                {type === 'purchase' ? (
                  ExtendedUpdateableFromSupplier &&
                  vendorType.toLowerCase() === 'supplier' &&
                  !isSeafreightLocked ? (
                    <Form.Control
                      size="sm"
                      type="number"
                      className="mr-2"
                      placeholder="Enter quantity"
                      value={line.vendorConfirmQty}
                      min={0}
                      onChange={(e) => {
                        editValue(documentNo, line.lineNo, {
                          vendorConfirmQty: Number(e.target.value)
                        });
                      }}
                      onWheel={(e) => e.target.blur()}
                      onFocus={(e) =>
                        e.target.addEventListener('wheel', (event) => event.preventDefault(), {
                          passive: false
                        })
                      }
                      onBlur={(e) =>
                        e.target.removeEventListener('wheel', (event) => event.preventDefault())
                      }
                    />
                  ) : (
                    line.vendorConfirmQty
                  )
                ) : (
                  line.qtyShipped
                )}
              </Descriptions.Item>
            )}
            <Descriptions.Item
              label={
                <InfoBox
                  title={'Root Cause'}
                  description="If a supplier confirms EGRD after PGRD, than the PO is NOT ON TIME and the root cause should be provided."
                  type={type}
                />
              }
            >
              {vendorType.toLowerCase() === 'supplier' ? (
                customReason === true || !lossReasonOptions.includes(line.lossReason) ? (
                  <Form.Control
                    as="textarea"
                    rows={1}
                    placeholder="Specify loss reason.."
                    value={line.lossReason}
                    maxLength={250}
                    onChange={(e) => {
                      if (e.target.value.trim() === '') {
                        setCustomReason(false);
                      } else {
                        setCustomReason(true);
                      }
                      editValue(documentNo, line.lineNo, { lossReason: e.target.value });
                    }}
                  />
                ) : (
                  <Form.Control
                    size="sm"
                    as="select"
                    value={line.lossReason}
                    onChange={(e) => {
                      if (e.target.value === 'Other (open answer)') {
                        setCustomReason(true);
                        editValue(documentNo, line.lineNo, { lossReason: ' ' });
                      } else {
                        setCustomReason(false);
                        editValue(documentNo, line.lineNo, { lossReason: e.target.value });
                      }
                    }}
                  >
                    {lossReasonOptions.map((option, index) => (
                      <option key={index}>{option}</option>
                    ))}
                  </Form.Control>
                )
              ) : (
                line.lossReason
              )}
            </Descriptions.Item>
            {type === 'purchase' && (
              <Descriptions.Item
                label={
                  <InfoBox
                    title="Shipping Method"
                    description="This refers to the way of the shipment of goods to the warehouse. It specifies where sea/rail/air or truck transportation will be used."
                    type={type}
                  />
                }
              >
                {line.vpFreightType === 'SeaRailAir' ? 'SeaRailAir' : 'Truck'}
              </Descriptions.Item>
            )}

            <Descriptions.Item
              label={
                <InfoBox
                  title="Expected GRD"
                  description="The date on which the supplier anticipates that the goods will be ready for pickup at their facilities. This date can be updated until the goods are shipped, and the most recent update will be considered the actual goods ready date."
                  type={type}
                />
              }
            >
              {ExtendedUpdateableFromSupplier && vendorType.toLowerCase() === 'supplier' ? (
                <Form.Control
                  id="expectedReceiptDate"
                  size="sm"
                  type="date"
                  className="mr-2"
                  value={expectedReceiptDate}
                  max={maxDate}
                  onChange={(e) => {
                    const selectedDate = new Date(e.target.value);
                    try {
                      const formattedDate = selectedDate.toISOString().split('T')[0];
                      setExpectedReceiptDate(formattedDate);
                      editValue(documentNo, line.lineNo, { [e.target.id]: e.target.value });
                      setIsInvalidExpectedDate(formattedDate > maxDate);
                    } catch (e) {}
                  }}
                  isInvalid={expectedReceiptDateState}
                />
              ) : (
                line.expectedReceiptDate
              )}
            </Descriptions.Item>

            <Descriptions.Item
              label={
                <InfoBox
                  title="Planned GRD"
                  description="Planned Good receipt date can only be updated from dynamics."
                  type={type}
                />
              }
            >
              {line.plannedReceiptDate}
            </Descriptions.Item>
            {type === 'purchase' && (
              <Descriptions.Item
                label={
                  <InfoBox
                    title="Expected Delivery Date"
                    description="If the shipping method is handled by the supplier, this is the projected date of arrival of the Purchase Order (PO) at the warehouse. It signifies the expected time when the goods are scheduled to be delivered to the warehouse, (moved to Shiptify)."
                    type={type}
                  />
                }
              >
                {line.expectedDeliveryDate}
              </Descriptions.Item>
            )}
            {type === 'purchase' && (
              <Descriptions.Item
                label={
                  <InfoBox
                    title="Actual Shipping Date"
                    description="The specific date on which the goods are physically shipped from the supplier's location. This date cannot be modified as it represents the factual shipping date, not an estimate, (moved to Shiptify)."
                    type={type}
                  />
                }
              >
                {line.actualShippingDate}
              </Descriptions.Item>
            )}
            {type === 'purchase' && vendorType.toLowerCase() === 'supplier' && (
              <Descriptions.Item label="Quantity Received">{line.qtyReceived}</Descriptions.Item>
            )}
            <Descriptions.Item
              label={
                <InfoBox
                  title={type === 'purchase' ? 'WH Confirm Quantity' : 'Quantity Received'}
                  description="The quantity of items actually received and confirmed by the warehouse upon delivery. This indicates the real quantity that the warehouse has on hand."
                  type={type}
                />
              }
            >
              {type === 'transfer' ? (
                <Form.Control
                  size="sm"
                  type="number"
                  className="mr-2"
                  placeholder="Enter received quantity"
                  value={line.qtyToReceive}
                  min={0}
                  onChange={(e) =>
                    editValue(documentNo, line.lineNo, { qtyToReceive: Number(e.target.value) })
                  }
                  onWheel={(e) => e.target.blur()}
                  onFocus={(e) =>
                    e.target.addEventListener('wheel', (event) => event.preventDefault(), {
                      passive: false
                    })
                  }
                  onBlur={(e) =>
                    e.target.removeEventListener('wheel', (event) => event.preventDefault())
                  }
                />
              ) : UpdatedableFromWarehouse &&
                vendorType.toLowerCase() === 'warehouse' &&
                !isSeafreightLocked ? (
                <Form.Control
                  size="sm"
                  type="number"
                  className="mr-2"
                  disabled={currentOrder.scheduledForPosting}
                  placeholder="Enter warehouse quantity"
                  value={
                    line.vpFreightType === 'SeaRailAir'
                      ? line.seaFreightConfirmedQty
                      : line.whseConfirmQty
                  }
                  min={0}
                  onChange={(e) => {
                    if (line.vpFreightType === 'SeaRailAir') {
                      editValue(documentNo, line.lineNo, {
                        seaFreightConfirmedQty: Number(e.target.value)
                      });
                    } else {
                      editValue(documentNo, line.lineNo, {
                        whseConfirmQty: Number(e.target.value)
                      });
                    }
                  }}
                  onWheel={(e) => e.target.blur()}
                  onFocus={(e) =>
                    e.target.addEventListener('wheel', (event) => event.preventDefault(), {
                      passive: false
                    })
                  }
                  onBlur={(e) =>
                    e.target.removeEventListener('wheel', (event) => event.preventDefault())
                  }
                />
              ) : (
                line.whseConfirmQty
              )}
            </Descriptions.Item>
            {type === 'purchase' && line.overReceiptCode !== '' && (
              <Descriptions.Item label="Over-Receipt Code">
                {line.overReceiptCode}
              </Descriptions.Item>
            )}
            <Descriptions.Item
              label={
                <InfoBox
                  title="WH Arrival Date"
                  description="The date when the Purchase Order (PO) arrives at the warehouse. It marks the point in time when the items ordered have been delivered to the warehouse location."
                  type={type}
                />
              }
            >
              {UpdatedableFromWarehouse && vendorType.toLowerCase() === 'warehouse' ? (
                <Form.Control
                  id="actualReceiptDate"
                  size="sm"
                  type="date"
                  className="mr-2"
                  disabled={currentOrder.scheduledForPosting}
                  value={actualReceiptDate}
                  max={maxDate}
                  onChange={(e) => {
                    const selectedDate = new Date(e.target.value);
                    try {
                      const formattedDate = selectedDate.toISOString().split('T')[0];
                      setActualReceiptDate(formattedDate);
                      editValue(documentNo, line.lineNo, { [e.target.id]: e.target.value });
                      setIsInvalidActualDate(formattedDate > maxDate);
                    } catch (e) {}
                  }}
                  isInvalid={actualReceiptDateState}
                />
              ) : (
                line.actualReceiptDate
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Quantity Damaged">
              {UpdatedableFromWarehouse && vendorType.toLowerCase() === 'warehouse' ? (
                <Form.Control
                  size="sm"
                  type="number"
                  className="mr-2"
                  disabled={currentOrder.scheduledForPosting}
                  placeholder="Enter damaged quantity"
                  value={line.qtyDmged}
                  min={0}
                  onChange={(e) =>
                    editValue(documentNo, line.lineNo, { qtyDmged: Number(e.target.value) })
                  }
                  onWheel={(e) => e.target.blur()}
                  onFocus={(e) =>
                    e.target.addEventListener('wheel', (event) => event.preventDefault(), {
                      passive: false
                    })
                  }
                  onBlur={(e) =>
                    e.target.removeEventListener('wheel', (event) => event.preventDefault())
                  }
                />
              ) : (
                line.qtyDmged
              )}
            </Descriptions.Item>
            {vendorType.toLowerCase() === 'supplier' && (
              <Descriptions.Item label="Quantity Missing">{line.qtyMissing}</Descriptions.Item>
            )}
            <Descriptions.Item
              label={
                <InfoBox
                  title={'Country of Origin *'}
                  description="Country code of the Country of Origin"
                  type={type}
                />
              }
            >
              {vendorType && vendorType.toLowerCase() !== 'warehouse' ? (
                <Form.Control
                  as="select"
                  value={line.mfgOriginCountry}
                  onChange={(e) =>
                    editValue(documentNo, line.lineNo, { mfgOriginCountry: e.target.value })
                  }
                >
                  <option value="">Select a country</option>
                  {CountriesOptions.map((country, index) => (
                    <option key={index} value={country}>
                      {country}
                    </option>
                  ))}
                </Form.Control>
              ) : (
                line.mfgOriginCountry
              )}
            </Descriptions.Item>
          </Descriptions>

          {isFeedBackLoopEnabled === true && (
            <>
              {(isFeedbackProcess || can_approve_po) && line.feedbackStatus === 'Pending' && (
                <div className={'mt-3'}>
                  <b style={{ color: '#FF5370' }}>Feedback Information</b>
                  <Descriptions bordered className={'mt-2'} colon={false}>
                    <Descriptions.Item label="Feedback Date" span={2}>
                      {feedbackDate}
                    </Descriptions.Item>
                    <Descriptions.Item label="Feedback Status">
                      {line.feedbackStatus}
                    </Descriptions.Item>
                    <Descriptions.Item label="Feedback user" span={2}>
                      {line.feedbackUser}
                    </Descriptions.Item>
                    <Descriptions.Item label="Feedback Type" span={3}>
                      {line.feedbackType}
                    </Descriptions.Item>
                  </Descriptions>
                  {line.approvable && isFeedbackProcess === true ? (
                    <Card.Footer>
                      <Row style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                          variant="danger"
                          onClick={() => submitFeedback('reject')}
                          className="mr-3"
                        >
                          Reject
                        </Button>
                        <Button variant="success" onClick={() => submitFeedback('approve')}>
                          Approve
                        </Button>
                      </Row>
                    </Card.Footer>
                  ) : (
                    <Alert variant={'warning'} className="mt-2">
                      <p>You don't have permission to approve this Feedback line.</p>
                    </Alert>
                  )}
                </div>
              )}
            </>
          )}
          {!line.isValid && <ul className="mt-4">{lineErrors}</ul>}
          {!line.isValid && <ul>{lineWarnings}</ul>}
          {showSaveButton && line.isEditing && (
            <Card.Footer>
              <Row style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="info"
                  onClick={() => (type === 'purchase' ? savePurchaseLine() : saveTransferLine())}
                >
                  Save
                </Button>
              </Row>
            </Card.Footer>
          )}
          {isFeedBackLoopEnabled === true && (
            <>
              {!line.isEditing &&
                line.feedbackStatus === 'Pending' &&
                isFeedbackProcess === false &&
                !can_approve_po && (
                  <Alert variant={'warning'} className="mt-2">
                    PO Line await feedback of type <u>{line.feedbackType}</u>
                  </Alert>
                )}

              {!line.isEditing && line.feedbackStatus === 'Rejected' && (
                <Alert variant={'danger'} className="mt-2">
                  PO Line feedback type <u>{line.feedbackType}</u> Rejected
                </Alert>
              )}

              {!line.isEditing && line.feedbackStatus === 'Approved' && (
                <Alert variant={'success'} className="mt-2">
                  PO Line feedback type <u>{line.feedbackType}</u> Approved
                </Alert>
              )}
            </>
          )}
        </Col>
      </Row>
    </Card>
  );
}

export default OrderLine;
